import {legacyPositiveId} from './legacyRecoverySources.js';

const parsed = value => typeof value === 'string' ? JSON.parse(value) : value;
const object = value => value && typeof value === 'object' && !Array.isArray(value);
export function isCurrentWebVisitRecord(type, raw, file) {
    const userId = legacyPositiveId(raw?.userId), visitaId = legacyPositiveId(raw?.visitaId);
    if (!userId || !visitaId) return false;
    if (type === 'ENTRIES') {
        const payload = parsed(raw.payload);
        return raw.key === `${userId}:${visitaId}` && typeof raw.revisionId === 'string' && !!raw.revisionId
            && !!object(payload?._local_first?.base) && !!object(payload.responses);
    }
    if (type === 'OPERATIONS') {
        return typeof raw.id === 'string' && !!raw.id && typeof raw.operation_uuid === 'string' && !!raw.operation_uuid
            && !!object(parsed(raw.payload)) && typeof raw.type === 'string' && !!raw.type;
    }
    if (type === 'MEDIA') return file?.schemaVersion === 1 && file.userId === userId && file.visitaId === visitaId
        && ['linked', 'acknowledged'].includes(file.state) && raw.filePath === file.path && raw.size === file.size
        && ![raw.file, raw.blob, raw.data, raw.base64, raw.bytes].some(value => value != null);
    if (type === 'FILES') return raw.schemaVersion === 1 && raw.path === `offline-files/${userId}/${raw.id}.bin`
        && typeof raw.sha256 === 'string' && /^[a-f0-9]{64}$/.test(raw.sha256) && Number.isSafeInteger(raw.size) && raw.size > 0;
    return false;
}
